import { useState } from "react"
import { Navigate, useSearchParams } from "react-router"
import styled from "styled-components"

import Button from "~/themes/school/components/Button"
import PartialLoadingPage from "~/themes/school/components/PartialLoadingPage"
import routes from "~/utilities/routes"
import trpc, { query } from "~/utilities/trpc"

import Layout, { Text } from "./Layout"

const InvitedSignupMembership: React.FC = () => {
	const inviteToken = useSearchParams()[0].get("invite")

	const [submittingPriceId, setSubmittingPriceId] = useState<number>()

	const { data: invite, error } = query.user.verifyStudentInviteToken.useQuery(inviteToken ?? "")

	if (inviteToken === null || error) return <Navigate to={routes.dashboard.index()} />

	if (invite !== undefined) {
		if (invite.status !== "success" || invite.invite.membership === null) {
			return <Navigate to={routes.dashboard.index()} />
		}
	}

	const handleStartMembership = async (priceId: number) => {
		if (invite === undefined) return

		setSubmittingPriceId(priceId)
		try {
			const result = await trpc.payment.joinMembershipPrice.mutate(priceId)
			if (result.status === "redirect") {
				window.location.assign(result.url)
			}
		} catch (error) {
			console.error(error)
			setSubmittingPriceId(undefined)
		}
	}

	return (
		<Layout title="Join membership">
			{invite === undefined ? (
				<PartialLoadingPage />
			) : (
				<>
					<Text>You have been invited to join the membership {invite.invite.membership!.title}.</Text>
					<Plans>
						{invite.invite.membership!.prices.map(price => (
							<Button
								key={price.id}
								variant="primary"
								isLoading={submittingPriceId === price.id}
								isDisabled={submittingPriceId !== undefined}
								onClick={() => handleStartMembership(price.id)}
							>
								Join for {price.price} {price.currency}/{price.paymentInterval}
							</Button>
						))}
					</Plans>

					<SkipStep>
						<Text>Don't want to join this membership?</Text>
						<Button
							variant="secondary"
							onClick={routes.dashboard.index()}
							isDisabled={submittingPriceId !== undefined}
						>
							Skip this step
						</Button>
					</SkipStep>
				</>
			)}
		</Layout>
	)
}

const Plans = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`

const SkipStep = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`

export default InvitedSignupMembership
